// extracted by mini-css-extract-plugin
module.exports = {"SearchBar":"searchBar_SearchBar__21WTe"};